import * as React from "react";
import { Navigate, Outlet, createRootRoute } from "@tanstack/react-router";
import LoadingScreen from "../components/LoadingScreen";
import useTranslation from "../hooks/useTranslation";

function RootErrorComponent() {
  const { translate } = useTranslation();

  return (
    <div className="flex min-h-dvh items-center justify-center bg-slate-50 px-4">
      <div className="flex max-w-sm flex-col items-center gap-4 text-center">
        <div className="rounded-full bg-red-50 p-4">
          <svg
            className="h-8 w-8 text-red-400"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
            />
          </svg>
        </div>
        <h2 className="text-lg font-semibold text-slate-800">
          {translate("unexpected_error_title")}
        </h2>
        <p className="text-sm leading-relaxed text-slate-500">
          {translate("unexpected_error_body")}
        </p>
        <div className="flex gap-3">
          <button
            onClick={() => window.location.reload()}
            className="rounded-md bg-slate-800 px-6 py-2.5 text-sm font-medium text-white hover:bg-slate-700 active:bg-slate-900"
          >
            {translate("unexpected_error_retry")}
          </button>
        </div>
      </div>
    </div>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: RootErrorComponent,
  notFoundComponent: () => <Navigate to="/app" replace />,
  wrapInSuspense: true,
});

function RootComponent() {
  if (__BUILD_VERSION__ === "dev") {
    console.log("[init] RootComponent rendered");
  }

  return (
    <React.Suspense fallback={<LoadingScreen />}>
      <Outlet />
    </React.Suspense>
  );
}
